import { createPlugin, createRoutableExtension } from '@backstage/core-plugin-api';

import { rootRouteRef, createNamespaceRouteRef } from './routes';

export const secretVaultPlugin = createPlugin({
  id: 'secret-vault',
  routes: {
    root: rootRouteRef,
    createNamespace: createNamespaceRouteRef,
  },
});

export const SecretVaultPage = secretVaultPlugin.provide(
  createRoutableExtension({
    name: 'SecretVaultPage',
    component: () => import('./components/Home').then(m => m.default),
    mountPoint: rootRouteRef,
  }),
);

export const CreateNamespacePage = secretVaultPlugin.provide(
  createRoutableExtension({
    name: 'CreateNamespacePage',
    component: () => import('./components/CreateNamespacePage').then(m => m.default),
    mountPoint: createNamespaceRouteRef,
  }),
);
